const initialState = {
  promptCollections: {},
  collectionsWithPromptPending: false,
  collectionsWithPromptError: null,
  createBulkCollectionsPending: false,
  createBulkCollectionsError: null,
  createAppPending: false,
  createAppError: null,
  addRolesAndUsersPending: false,
  addRolesAndUsersError: null,
  fetchPagesPending: false,
  fetchPagesError: null,
  optimalPages: [],
  generateHtmlForPagesPending: false,
  generateHtmlForPagesError: null,
  createPagePending: false,
  createPageError: null,
  figmaTokenSubmitPending: false,
  figmaTokenSubmitError: null,
  fetchTokenDetailsPending: false,
  fetchTokenDetailsError: null,
  fetchFigmaImagePending: false,
  fetchFigmaImageError: null,
  generateDefaultLayoutsPending: false,
  generateDefaultLayoutsError: null,
  generateFigmaLayoutsPending: false,
  generateFigmaLayoutsError: null,
  generateImageLayoutsPending: false,
  generateImageLayoutsError: null,
};

export default initialState;
